var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.auth0FFEnabled)?_c('auth0-login-page'):_c('login-template',{class:_vm.backgroundClassName,scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('online-portal-login-header')]},proxy:true},{key:"loginContent",fn:function(){return [_c('router-view')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }